import { useTranslation } from 'react-i18next';
import { useCallback, useMemo } from 'react';

export function useLanguage() {
  const { i18n } = useTranslation();

  const language = i18n.language as 'en' | 'ar';
  const direction = language === 'ar' ? 'rtl' : 'ltr';
  const isRTL = language === 'ar';

  const toggleLanguage = useCallback(() => {
    const next = language === 'en' ? 'ar' : 'en';
    i18n.changeLanguage(next);
  }, [language, i18n]);

  const setLanguage = useCallback(
    (lng: 'en' | 'ar') => {
      i18n.changeLanguage(lng);
    },
    [i18n],
  );

  return useMemo(
    () => ({ language, direction, isRTL, toggleLanguage, setLanguage }),
    [language, direction, isRTL, toggleLanguage, setLanguage],
  );
}
